import {ActivatedRouteSnapshot, Data, NavigationEnd, Router} from "@angular/router";
import {TrackingEvent} from "./tracking-event";
import {takeUntilDestroyed, toSignal} from "@angular/core/rxjs-interop";
import {filter} from "rxjs";
import {effect, Signal} from "@angular/core";
import {CookieYesCategory} from "../services/consent.service";

/**
 * Route data enabling analytics and marketing scripts for the route and its children.
 */
export const TRACKING_ENABLED: Data = {tracking: true};

export interface Tracker {
  category(): CookieYesCategory;

  enable(): void;

  disable(): void;

  trackPageView(path: string): void;

  trackCustomEvent(event: TrackingEvent): void;
}

export function trackConsentChange(tracker: Tracker, consent: Signal<boolean>) {
  effect(() => {
    const consentGranted = consent();
    console.debug("Consent changed for ", tracker, " -> ", consentGranted);
    consentGranted ? tracker.enable() : tracker.disable();
  });
}

export function trackPageView(tracker: Tracker,
                              router: Router,
                              consent: Signal<boolean>) {
  const navigation = toSignal(router.events.pipe(
    takeUntilDestroyed(),
    filter(event => event instanceof NavigationEnd))
  );
  let lastTrackedNavigationId: number | undefined;
  effect(() => {
    const navigationEnd = navigation();
    const allowedToTrack = consent() && trackingEnabled(router.routerState.snapshot.root);
    console.debug("Tracking page view, lastNavigationId: ", lastTrackedNavigationId, ", allowed: ", allowedToTrack, ", navigation: ", navigationEnd);
    if (allowedToTrack && navigationEnd && navigationEnd.id !== lastTrackedNavigationId) {
      console.debug("Sending page view for ", tracker);
      lastTrackedNavigationId = navigationEnd.id;
      tracker.trackPageView(navigationEnd.urlAfterRedirects);
    }
  });
}

function trackingEnabled(route: ActivatedRouteSnapshot): boolean {
  return route.data['tracking'] === true || route.children.some(trackingEnabled);
}
